import React, { useState } from "react";

import axios from "axios";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
export default function CreateSupportRequestModal({ cancelModal }) {
  const [subject, setSubject] = useState("");
  const [subjectErr, setSubjectErr] = useState("");
  const [context, setContext] = useState("");
  const [contextErr, setContextErr] = useState("");
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthContext();
  const [category, setCategory] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubjectErr("");
    setContextErr("");
    let error = false;
    //Subject Validations
    if (subject.length > 100) {
      error = true;
      setSubjectErr("The subject cannot exceed 100 characters.");
    }
    if (context.length > 100) {
      error = true;
      setContextErr("The context cannot exceed 3000 characters.");
    }
    if (!error) {
      setIsLoading(true);

      const createSupportRequest = {
        subject,
        context,
        category,
      };

      try {
        const supportRequestResponse = await axios.post(
          `${ApiConnectionString}/api/SupportRequest`,
          createSupportRequest,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (supportRequestResponse.status == 200) {
          setComplete(true);
        }
      } catch (error) {
        console.error("Error submitting support request:", error);
        // Handle the error as needed, e.g., show an error message to the user
      } finally {
        setIsLoading(false);
      }
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    if (!complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner d-flex justify-content-between align-items-center">
              <h3 className="p-2">Support Request</h3>
              <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="d-flex justify-content-center p-0 m-0">
                <hr className="dashed w-100" />
              </div>
              <div className="form-group">
                <label htmlFor="category">Category:</label>
                <select
                  id="category"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  required
                >
                  <option value="">Select a category</option>
                  <option value="technical">Technical Issue</option>
                  <option value="billing">Billing Inquiry</option>
                  <option value="general">General Question</option>
                  <option value="feedback">Feedback</option>
                </select>
              </div>
              <div className="d-flex justify-content-center p-0 m-0">
                <hr className="dashed w-100" />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject:</label>
                <input
                  type="text"
                  id="subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                />
                {subjectErr && <p className="text-danger">{subjectErr}</p>}
              </div>
              <div className="d-flex justify-content-center p-0 m-0">
                <hr className="dashed w-100" />
              </div>
              <div className="form-group">
                <label htmlFor="context">Context:</label>
                <textarea
                  id="context"
                  value={context}
                  onChange={(e) => setContext(e.target.value)}
                  required
                  rows={5}
                />
                {contextErr && <p className="text-danger">{contextErr}</p>}
              </div>
              <div className="d-flex justify-content-center p-0 m-0">
                <hr className="dashed w-100" />
              </div>
              <div className="send-modal-footer">
                <button type="submit" className="saveChanges-button mx-5">
                  Submit
                </button>

                <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">
                Support Request Created
              </p>
            </div>

            <p>
              Thank you for submitting a support request. We will respond to you
              as soon as we can.
            </p>

            <div className="send-modal-footer">
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={cancelModal}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
